module.exports = __webpack_public_path__ + "img/e2c006e7b54b8f275d6d12f70d61c2a7.svg";